<template>
<Popover
    arrow
    :theme="theme"
    :visible="visible"
    @update:visible="handleVisibleChange"
    :trigger="trigger"
    :modifiers="modifiers"
    :popoverClass="[bem(), popoverClass]"
    :component="component"
    :placement="placement"
    :el="el"
    :appendToBody="appendToBody"
    :delayonMouseLeave="delayonMouseLeave"
>
    <slot />
    <template slot="content">
        <slot name="content">
            <Vnode :content="content" />
        </slot>
    </template>
</Popover>

</template>
<script>
import {bemMixin, hasProp} from "../utils";
import Popover from "../popover/index.vue";
import Vnode from "../v-node/index.vue";
export default {
  name: "g-tooltip",
  components: {
    Popover,
    Vnode
  },
  mixins: [bemMixin],
  props: {
    content: {
      type: [String, Object],
      default: ""
    },
    popoverClass: {
      type: [String, Array],
      default: ""
    },
    modifiers: Object,
    visible: {
      type: Boolean,
      default: void 0
    },
    trigger: {
      type: String,
      default: "hover",
      validator: (value) => ["click", "hover", "focus"].indexOf(value) > -1
    },
    theme: {
      type: String,
      default: "dark"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    component: {
      type: [String, Object],
      default: "span"
    },
    el: String,
    appendToBody: {
      type: Boolean,
      default: false
    },
    delayonMouseLeave: {
      type: Number,
      default: 100
    }
  },
  methods: {
    handleVisibleChange(value) {
      this.$emit("update:visible", value);
    }
  }
};

</script>
<style>
.g-tooltip.g-tooltip {
  padding: 8px 16px;
  border-radius: 4px;
}

</style>
